import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { siteData } from '../mockData';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
    isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'}`
    }>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="flex items-center space-x-3">
              <img
                src={siteData.images.nameLogo}
                alt="Mazen El-Majzoub Real Estate logo"
                width="48"
                height="48"
                className="h-12 w-auto"
              />
              <div>
                <div className="text-sm font-semibold tracking-wide text-gray-800">MAZEN EL-MAJZOUB</div>
                <div className="text-xs tracking-widest text-gray-600">REDEFINING EXCELLENCE</div>
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {siteData.navigation.map((item) =>
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm font-medium transition-colors hover:text-gray-900 ${
              location.pathname === item.path ? 'text-gray-900' : 'text-gray-600'}`
              }>

                {item.label}
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-gray-600 hover:text-gray-900"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>

            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen &&
      <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-3">
            {siteData.navigation.map((item) =>
          <Link
            key={item.path}
            to={item.path}
            className={`block py-2 text-sm font-medium transition-colors ${
            location.pathname === item.path ? 'text-gray-900' : 'text-gray-600'}`
            }
            onClick={() => setIsMobileMenuOpen(false)}>

                {item.label}
              </Link>
          )}
          </div>
        </div>
      }
    </nav>);

};

export default Navigation;